import React from 'react';
import VerifyEmailComponent from '../../../../Components/UserComponents/Register/VerifyEmail';

const VerifyEmailContainer = () => {
  return <VerifyEmailComponent />;
};

export default VerifyEmailContainer;
